export default {
  // Footer
  'navigation:common:footer:about-us': 'Over ons',
  'navigation:common:footer:faq': 'FAQ',
  'navigation:common:footer:brand-ambassador': 'Merkambassadeur worden',
  'navigation:common:footer:bonus-program': 'Bonusprogramma',
  'navigation:common:footer:jobs': 'Vacatures / Carrière',

  // Trustbar
  'navigation:common:trustbar:consultation': 'Advies',
  'navigation:common:trustbar:magazine': 'Magazine',
  'navigation:common:trustbar:faq': 'FAQ',
  'navigation:common:trustbar:bonus-program': 'Bonusprogramma',

  // Navigation Menu Items
  'navigation:menu:home': 'Home',
  'navigation:menu:dogs:home': 'Honden',
  'navigation:menu:cats:home': 'Katten',

  // Dogs Common Needs
  'navigation:dogs:needs:title': 'Op behoefte',
  'navigation:dogs:needs:picky-eaters': 'Kieskeurige eters',
  'navigation:dogs:needs:digestive-problems': 'Spijsverteringsproblemen',
  'navigation:dogs:needs:skin-fur-problems': 'Huid- & vachtproblemen',
  'navigation:dogs:needs:intolerances': 'Intoleranties',
  'navigation:dogs:needs:overweight': 'Overgewicht',

  // Dogs Age Categories
  'navigation:dogs:age:title': 'Op leeftijd',
  'navigation:dogs:age:puppy': 'Puppy (0-1 jaar)',
  'navigation:dogs:age:adult': 'Adult (1-8 jaar)',
  'navigation:dogs:age:senior': 'Senior (8+ jaar)',

  // Dogs Breeds
  'navigation:dogs:breeds:title': 'Op ras',
  'navigation:dogs:breeds:bulldog': 'Bulldog',
  'navigation:dogs:breeds:chihuahua': 'Chihuahua',
  'navigation:dogs:breeds:dachshund': 'Teckel',
  'navigation:dogs:breeds:havanese-maltese': 'Havanezer & Maltezer',
  'navigation:dogs:breeds:poodle': 'Poedel & poedelmix',
  'navigation:dogs:breeds:retriever': 'Retriever',
  'navigation:dogs:breeds:shepherd': 'Herdershond',
  'navigation:dogs:breeds:spitz': 'Spits',
  'navigation:dogs:breeds:terrier': 'Terriër',
  'navigation:dogs:breeds:herding': 'Herdershond',

  // Dogs Food Types
  'navigation:dogs:food:wet': 'Natvoer',
  'navigation:dogs:food:dry': 'Droogvoer',

  // Dogs Product Types
  'navigation:dogs:products:sample-packs': 'Probeerpakketten',
  'navigation:dogs:products:wet-food': 'Natvoer',
  'navigation:dogs:products:dry-food': 'Droogvoer',
  'navigation:dogs:products:barf': 'BARF',
  'navigation:dogs:products:snacks': 'Snacks',

  // Dogs Snacks
  'navigation:dogs:snacks:title': 'Snacks',
  'navigation:dogs:snacks:all': 'Alle snacks',
  'navigation:dogs:snacks:surprise-box': 'Verrassingsbox',
  'navigation:dogs:snacks:dental-care': 'Gebitsverzorging',
  'navigation:dogs:snacks:functional': 'Functional Snacks',
  'navigation:dogs:snacks:bones': 'Botten & kauwrollen',
  'navigation:dogs:snacks:strips': 'Kauwstrips & sticks',
  'navigation:dogs:snacks:training': 'Trainingssnacks',
  'navigation:dogs:snacks:pastes': "Pasta's & crèmesnacks",
  'navigation:dogs:snacks:toppers': 'Toppers',

  // Dogs Accessories and Health
  'navigation:dogs:accessories:title': 'Accessoires',
  'navigation:dogs:health:title': 'Verzorging & gezondheid',
  'navigation:dogs:health:general': 'Gezondheid',
  'navigation:dogs:products:accessories': 'Accessoires',
  'navigation:dogs:products:health': 'Gezondheid',

  // Dogs Additional Categories
  'navigation:dogs:categories:care': 'Verzorging',
  'navigation:dogs:categories:supplements': 'Voedingssupplementen',

  // Cats Navigation
  'navigation:cats:products:wet-food': 'Natvoer',
  'navigation:cats:products:dry-food': 'Droogvoer',
  'navigation:cats:products:snacks': 'Snacks',
  'navigation:cats:products:sample-packs': 'Probeerpakketten',
  'navigation:cats:products:accessories': 'Accessoires',
  'navigation:cats:products:health': 'Gezondheid',
  'navigation:cats:products:care': 'Verzorging',
  'navigation:cats:products:supplements': 'Voedingssupplementen',

  // Cats Needs
  'navigation:cats:needs:title': 'Speciale behoeften',
  'navigation:cats:needs:picky-eaters': 'Zeer kieskeurig',
  'navigation:cats:needs:digestive-problems': 'Spijsverteringsproblemen',
  'navigation:cats:needs:outdoor': 'Buitenkat',
  'navigation:cats:needs:overweight': 'Overgewicht',
  'navigation:cats:needs:sterilized': 'Gesteriliseerd',

  // Cats Age
  'navigation:cats:age:title': 'Op leeftijd',
  'navigation:cats:age:kitten': 'Kitten (0-1 jaar)',
  'navigation:cats:age:adult': 'Adult (1-10 jaar)',
  'navigation:cats:age:senior': 'Senior (10+ jaar)',

  // Cats Snacks
  'navigation:cats:snacks:title': 'Snacks',
  'navigation:cats:snacks:all': 'Alle snacks',
  'navigation:cats:snacks:surprise-box': 'Verrassingsbox',
  'navigation:cats:snacks:cream': 'Crème Snacks',
  'navigation:cats:snacks:soft': 'Soft Snacks',
  'navigation:cats:snacks:fillet': 'Filet Snacks',
  'navigation:cats:snacks:soups': 'Soepen',
  'navigation:cats:snacks:sensitive': 'Sensitief',
  'navigation:cats:snacks:pastes': "Pasta's",

  // Common Service
  'navigation:common:service:title': 'Service',
  'navigation:common:service:dr-sam': 'Dr. Sam',
  'navigation:common:service:doguniversity': 'Doguniversity',
  'navigation:common:service:lassie': 'Lassie',

  // Footer - Useful Information
  'navigation:footer:useful:about-us': 'Over ons',
  'navigation:footer:useful:healthy-pet-food': 'Wat is gezonde diervoeding?',
  'navigation:footer:useful:premium-food': 'Waarom premium diervoeding?',
  'navigation:footer:useful:food-transition': 'Voeromschakeling',
  'navigation:footer:useful:our-stores': 'Onze winkels',

  // Footer - Good For You
  'navigation:footer:good:refer-friends': 'Vrienden aanbevelen',
  'navigation:footer:good:become-ambassador': 'Merkambassadeur worden',
  'navigation:footer:good:savings-subscription': 'Ons voordeelabonnement',

  // Footer - Help
  'navigation:footer:help:faq': 'Veelgestelde vragen',
  'navigation:footer:help:shipping': 'Verzending',
  'navigation:footer:help:retail': 'Pets Deli in de winkel',
  'navigation:footer:help:breeder-program': 'Fokkersprogramma',

  // Footer - Legal
  'navigation:footer:legal:jobs': 'Vacatures',
  'navigation:footer:legal:imprint': 'Colofon',
  'navigation:footer:legal:privacy': 'Privacy',
  'navigation:footer:legal:terms': 'Algemene voorwaarden en herroeping',

  // Common
  'navigation:common:offers': 'Aanbiedingen',

  // Header - Mobile
  'navigation:mobile:aria-label': 'Navigatie in- of uitklappen',
};
